import { Component } from '@angular/core';
import { HeaderComponent } from '../components/header/header.component';
import { ImageToText1Component } from '../components/image-to-text/image-to-text.component';

@Component({
  selector: 'app-ocr',
  standalone:true,
    imports: [ HeaderComponent,ImageToText1Component],
  templateUrl: './ocr.component.html',
  styleUrls: ['./ocr.component.scss']
})
export class OCRComponent {

}
